export let computeFaqClick = () => {
  const faq = $('[data-faq-click]');
  if (faq.length) {
    faq.click(function () {
      if ($(this).attr('aria-expanded') === 'false') {
        const faq_path = this.getAttribute('data-faq-path');
        $.ajax({
          url: faq_path,
          type: 'POST'
        });
      }
    });
  }
};
